import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';

import { SnackbarService } from "../../shared/components/snackbar/snackbar.service";
import { TimeSlot } from "../../trains/models/time-slot.entity";
import { DynamicType } from "../models/dynamic.model";
import { ThematicRepository } from "../repositories/thematic.repository";


@Injectable()
export class TimeslotResolver  {
  constructor(private readonly thematicRepository: ThematicRepository,
              private readonly snackbarService: SnackbarService,
              private readonly router: Router,
  ) {
    this.handleError = this.handleError.bind(this);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<TimeSlot[] | undefined> {
    const slug = route.paramMap.get('slug') ?? '';
    const dynamicType = route.paramMap.get('dynamic') ?? '';
    if (dynamicType === '') {
      return of([]);
    }

    return this.thematicRepository.getTimeSlots(slug, dynamicType as DynamicType)
      .pipe(catchError(err => this.handleError(err)));
  }

  private handleError(err: HttpErrorResponse): Observable<TimeSlot[] | undefined> {
    if (err.status === 404) {
      this.snackbarService.pushMessage('La dynamique recherchée est introuvable', 'error');
    }
    this.router.navigate([ 'thematics' ]);

    return of(undefined);
  }
}
